import angular from 'angular';

const ngRoute = require('angular-route');
import routing from './dashboard.routes';
var localisations = require('./dashboard.localisations');

export class DashboardController {
  constructor($http, $scope, socket, common, Auth, subjects, $location, $timeout) {
    'ngInject';
    var that = this;
    this.$http = $http;
    this.$scope = $scope;
    this.socket = socket;
    this.location = $location;
    this.$timeout = $timeout;
    this.common = common;
    this.common.setPageTitle('');
    this.common.setBack(null, null);
    this.subjects = subjects;
    this.Auth = Auth;
    this.removingQuestion = false;
    this.toggling = false;
    this.showAddressReq = false;
    this.newAddress = '';
    this.country = '';
    this.gender = '';
    this.ethnicity = '';
    this.yg = '';
    this.agerange = '';
    this.additionalhelp = '';
    this.socialApps = [];
    this.Auth.getCurrentUser(function(user) {
      that.currentUser = user;
      //Removed the opinionProfile.completed check as instructed
      //if (that.currentUser.opinionProfile.completed) {
        that.$timeout(function(){
          if (that.currentUser.role == 'admin' || that.currentUser.role == 'moderator') {
            that.location.path('/allgroups');
          } else {
            that.location.path('/messages');
          }
        }, 150)
      /*} else {
        if (that.currentUser.opinionProfile.subjects.length <= 0) {
          that.subjects.initialise(function(subjects){
            that.subjects.setupMidPoint();
            that.currentUser.opinionProfile.subjects = that.subjects.getSubjects();
            console.log(that.currentUser);
            common.setLoading(false);
          }, function(){
            common.setLoading(false);
          });
        }
      }*/
    });
    this.newNoGo = '';
    this.placeholder = 'Enter off-limits Topic';
    this.localisations = localisations[this.common.getLocale()];
  }

  toggleNoGo(e, topic) {
    console.log('Topic', topic, this.newNoGo);
    var that = this;
    e.stopPropagation();
    if (!this.toggling) {
      this.toggling = true;
      if (typeof topic == 'undefined') {
        var text = this.newNoGo;
      } else {
        var text = topic;
      }
      console.log('Text', text);
      this.$timeout(function(){
        console.log('Go to the timeout.');
        if (typeof that.currentUser.opinionProfile.noGoTopics == 'undefined') {
          that.currentUser.opinionProfile.noGoTopics = [text];
        } else {
          var riIndex = that.currentUser.opinionProfile.noGoTopics.indexOf(text);
          if (riIndex > -1) {
            that.currentUser.opinionProfile.noGoTopics.splice(riIndex, 1);
          } else {
            that.currentUser.opinionProfile.noGoTopics.push(text);
          }
        }
        that.newNoGo = '';
        that.toggling = false;
      }, 150);
    }
  }

  toggleSocialApps(e, text) {
    e.stopPropagation();
    if (this.socialApps.indexOf(text) > -1) {
      this.socialApps.splice(riIndex, 1);
    } else {
      this.socialApps.push(text);
    }
  }

  socialAppToggled(text) {
    console.log(text);
    console.log(this.socialApps.indexOf(text) > -1);
    return (this.socialApps.indexOf(text) > -1);
  }

  toggleRanked(e, text) {
    var that = this;
    e.stopPropagation();
    if ((!this.toggling && that.currentUser.opinionProfile.rankedItems.length < 5) || that.currentUser.opinionProfile.rankedItems.indexOf(text) > -1) {
      this.toggling = true;
      this.$timeout(function(){
        if (typeof that.currentUser.opinionProfile.rankedItems == 'undefined') {
          that.currentUser.opinionProfile.rankedItems = [text];
        } else {
          var riIndex = that.currentUser.opinionProfile.rankedItems.indexOf(text);
          if (riIndex > -1) {
            that.currentUser.opinionProfile.rankedItems.splice(riIndex, 1);
          } else {
            that.currentUser.opinionProfile.rankedItems.push(text);
          }
        }
        that.toggling = false;
      }, 150);
    }
  }

  isRanked(text) {
    if (typeof this.currentUser != 'undefined') {
      return this.currentUser.opinionProfile.rankedItems.indexOf(text) > -1;
    } else {
      return false;
    }
  }

  removeQuestion(e, subjectIndex, scaleIndex) {
    var that = this;
    e.stopPropagation();
    if (!this.removingQuestion) {
      this.removingQuestion = true;
      this.$timeout(function(){
        console.log('removing', subjectIndex, scaleIndex);
        if (typeof that.currentUser.opinionProfile.subjects[subjectIndex].scales[scaleIndex].notbothered != 'undefined') {
          that.currentUser.opinionProfile.subjects[subjectIndex].scales[scaleIndex].notbothered = !that.currentUser.opinionProfile.subjects[subjectIndex].scales[scaleIndex].notbothered;
        } else {
          that.currentUser.opinionProfile.subjects[subjectIndex].scales[scaleIndex].notbothered = true;
        }
        that.removingQuestion = false;
      }, 150);
    }
  }

  saveUserOpinionProfile() {
    var that = this;
    console.log('Saving');

    this.common.setLoading(true);
    console.log('Sending to Auth', this.currentUser.opinionProfile);
    this.subjects.weightScores(this.currentUser.opinionProfile.subjects, function(newSubjects){
      that.currentUser.opinionProfile.subjects = newSubjects;
      that.currentUser.opinionProfile.completed = true;
      that.Auth.updateProfile(that.currentUser.name, that.currentUser.email, that.currentUser.title, that.currentUser.opinionProfile, that.currentUser.anonymous, function() {
        console.log('Saved all good');
        that.common.setLoading(false);
        if (that.currentUser.role == 'admin') {
          that.location.path('/allgroups');
        } else {
          that.showAddressReq = true;
        }
      }, function() {
        console.log('Saved all bad');
        that.common.setLoading(false);
        that.common.setAlert('Save Error', 'danger', 'Looks like there is a problem saving your profile. Please check the details and try again.', false, true);
      });
    }, function(errorMessage){
      console.log('Saved all bad - weighting calc issue', subjects);
      this.common.setLoading(false);
      that.common.setAlert('Save Error', 'danger', `Looks like there is a problem saving your profile. Please check the details and try again. (${errorMessage})`, false, true);
    });
  }

  sendAddress() {
    var that = this;
    this.common.sendUserAddress({
      address: this.newAddress,
      country: this.country,
      gender: this.gender,
      ethnicity: this.ethnicity,
      yeargroup: this.yg,
      agerange: this.agerange,
      socialapps: this.socialApps,
      additionalhelp: this.additionalhelp
    }, function(response) {
      that.common.setLoading(false);
      that.location.path('/group');
    }, function(error) {
      that.common.setLoading(false);
      // error already reported.
    });
  }

  openPreSurvey() {
    //set opinionProfile to completed and redirect (new window)
    window.open('https://docs.google.com/forms/d/1W6HERCp1Ge05F70k2euO2vZFNmHi3vrdztyxFynyAG4/edit?ts=6641ccd3', '_blank');
    this.saveUserOpinionProfile();
    this.location.path('/messages');
  }
}

export default angular.module('ffApp.dashboard', [ngRoute])
  .config(routing)
  .component('dashboard', {
    template: require('./dashboard.html'),
    controller: DashboardController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/dashboard/dashboard.component.js